import * as React from "react";
const SvgFiRrStarShooting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-shooting_svg__a)">
      <path
        fill="#062147"
        d="m23.708 1.694-10 10a.997.997 0 0 1-1.415 0 1 1 0 0 1 0-1.414l10-10a.999.999 0 1 1 1.415 1.414M8 8.987a1 1 0 0 0 .707-.293l5-5a.999.999 0 1 0-1.414-1.414l-5 5A.999.999 0 0 0 8 8.987m12.294 1.293-5 5a.999.999 0 1 0 1.413 1.414l5-5a.999.999 0 1 0-1.413-1.414M11 15.987H7.999l-1.062-2.852a1.001 1.001 0 0 0-1.874 0l-1.062 2.852h-3a1 1 0 0 0-.647 1.762l2.377 1.934-.94 3.016a1.003 1.003 0 0 0 .953 1.3 1 1 0 0 0 .556-.168l2.708-1.812 2.754 1.793a1.002 1.002 0 0 0 1.495-1.152l-.979-2.98 2.367-1.927A1 1 0 0 0 11 15.987"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-shooting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarShooting;
